import { createContext } from '@lit/context'
import { InternalProduct } from 'components/discovery/product/tile-parts/tile-parts-typing.js'

export const productTileProductContext = createContext<InternalProduct>(
  Symbol('cs-product-tile-product-data-context')
)

export const productTileIndexContext = createContext<number | undefined>(
  Symbol('cs-product-tile-index-context')
)
